import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import type { QualificationSubGroup as QualificationSubGroupType, QualificationLevel } from '../types';
import {StatusIcon} from '../StatusIcon';
import QualificationItemComponent from '../QualificationItemComponent';

export const QualificationSubGroup: React.FC<{ subGroup: QualificationSubGroupType | QualificationLevel; level?: number }> = ({ subGroup, level = 1 }) => (
  <Box sx={{ ml: level * 2 }}>
    <Accordion
      disableGutters
      square
      sx={{
        backgroundColor: 'transparent',
        boxShadow: 'none',
        mb: 0,
        '&:before': { display: 'none' },
        border: 'none',
      }}
    >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon sx={{ fontSize: '1rem', color: '#1976d2' }} />}
      sx={{
        minHeight: '32px',
        px: 0,
        py: 0,
        '& .MuiAccordionSummary-content': { margin: 0 },
      }}
    >
      <Box 
        display="flex" 
        alignItems="center" 
        width="100%" 
        sx={{ 
            backgroundColor: level <= ((subGroup as QualificationLevel).level ? 3 : 2) ? '#f0f4ff' : '#ffffff',
          px: 1.5,
          py: 0.5
        }}
      >
        <Box flex={1}>
          <Typography 
            fontSize={level === 1 ? "0.9rem" : (level === 2 || ((subGroup as QualificationLevel).level && level === 3)) ? "0.85rem" : "0.8rem"}
            fontWeight={level === 1 ? "500" : "400"}
            color="#444"
          >
            {(subGroup as QualificationSubGroupType).subGroup ?? (subGroup as QualificationLevel).level}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center">
          <StatusIcon status={subGroup.status || 'invalid'} />
          <Typography fontSize="0.875rem">{subGroup.statusMessage}</Typography>
        </Box>
      </Box>
    </AccordionSummary>

    <AccordionDetails sx={{ px: 0, py: 0 }}>
      {(subGroup as QualificationSubGroupType).subGroups?.map((nestedSubGroup, idx) => (
        <QualificationSubGroup key={idx} subGroup={nestedSubGroup} level={(level || 1) + 1} />
      ))}
      {(subGroup as QualificationSubGroupType).levels?.map((nestedLevel, idx) => (
        <QualificationSubGroup key={idx} subGroup={nestedLevel} level={(level || 1) + 1} />
      ))}
      {(subGroup as QualificationSubGroupType).items?.map((item, idx) => (
        <Box key={idx} sx={{ ml: (level || 1) + 2 }}>
          <QualificationItemComponent item={item} />
        </Box>
      ))}
    </AccordionDetails>
    </Accordion>
  </Box>
);

// export default QualificationSubGroup;
